
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import JyotishLinks from '../../../components/JyotishLinks/JyotishLink';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './Rashifal.scss';

// Rashifal types
const rashifalTypes = [
  { id: 1, name: 'Daily Rashifal', img: 'https://img.icons8.com/color/96/calendar--v1.png' },
  { id: 2, name: 'Weekly Rashifal', img: 'https://img.icons8.com/color/96/calendar-week.png' },
  { id: 3, name: 'Monthly Rashifal', img: 'https://img.icons8.com/color/96/calendar-31.png' },
  { id: 4, name: 'Yearly Rashifal', img: 'https://img.icons8.com/color/96/planner.png' },
];

const Rashifal = () => {
  return (
    <div className="rashifal-container">
      <InnerNav />
      <div className="rashifal-content">
        <Zodiac />

        <div className="rashifal-header">
          <h4>Rashifal - Horoscope Forecasts</h4>
        </div>

        <div className="rashifal-grid">
          {rashifalTypes.map((item) => (
            <div className="rashifal-card" key={item.id}>
              <img src="https://coreldrawdesign.com/resources/previews/preview-hindu-rashi-astrological-sign-zodiac-astrology-chakra-vector-download-for-free-with-cdr-file-1714723983.webp"alt={item.name} />
              <p>{item.name}</p>
            </div>
          ))}
        </div>

        <JyotishLinks/>
      </div>
      <Footer />
    </div>
  );
};

export default Rashifal;
